import { MouseEventHandler } from "react";
import {
  AuthenticationError,
  AuthenticationResult,
  RegisterButtonProps,
} from "../../types/registerButtonProps";
import { Button } from "../Button";
const { startUserRegistration } = require("@sonr-io/webauthn");

export function RegisterButton(registerButtonProps: RegisterButtonProps) {
  function onClickWrapper(
    callback: AuthenticationResult,
    errorCallback: AuthenticationError
  ): MouseEventHandler<HTMLButtonElement> {
    return (_e: any) => {
      if (process.env.ENV_NAME === 'STORYBOOK') return;

      startUserRegistration({
        deviceLabel: registerButtonProps.deviceLabel,
        name: registerButtonProps.domain,
        crossOrigin: false,
        rpId: "Sonr",
      })
        .then((result: PublicKeyCredential) => {
          callback && callback(result);
        })
        .catch((error: any) => {
          errorCallback && errorCallback(error);
        });
    };
  }

  return (
    <div className="inline-flex items-center mx-auto">
      <Button
        size={registerButtonProps.size}
        iconName={registerButtonProps.iconName}
        iconType={registerButtonProps.iconType}
        label={registerButtonProps.label}
        skin={registerButtonProps.skin}
        styling={registerButtonProps.styling}
        onClick={onClickWrapper(
          registerButtonProps.onRegister,
          registerButtonProps.onError
        )}
      />
    </div>
  );
}
